import { useCallback, useRef, type KeyboardEvent } from 'react';
import type { AiPromptPanelProps } from '../../AiPromptPanel.types';

type UseAiPromptPanelOptions = Pick<AiPromptPanelProps, 'onSend' | 'isGenerating'>;

export function useAiPromptPanel(options: UseAiPromptPanelOptions) {
  const { onSend, isGenerating } = options;
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  const handleKeyDown = useCallback(
    (event: KeyboardEvent<HTMLTextAreaElement>) => {
      if (event.key === 'Enter' && !event.shiftKey) {
        event.preventDefault();
        if (!isGenerating) {
          onSend();
        }
      }
    },
    [isGenerating, onSend],
  );

  return { textareaRef, handleKeyDown };
}
